import { FC, useMemo } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { ToggleGroupButtonProps } from './types';
import classNames from 'classnames';
import _ from 'lodash';

const ToggleGroupButton: FC<ToggleGroupButtonProps> = ({
  name = 'toggle-group',
  defaultValue,
  value = '',
  options,
  onChange = () => {},
  size = 'sm',
  className = '',
  containerClassName = '',
  style = 'rounded',
}) => {
  const idPrefix = useMemo(() => _.uniqueId(), []);

  return (
    <ToggleButtonGroup
      type="radio"
      name={name}
      size={size}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      className={`toggle-btn-${style} ${containerClassName}`}
    >
      {options.map((option) => {
        const {
          value,
          disabled = false,
          onClick = () => {},
          shouldShow = true,
          iconName = '',
          label = '',
        } = option;

        if (!shouldShow) return null;

        const active = defaultValue === value;
        const combinedClassName = classNames(className, {
          active: active,
        });

        return (
          <ToggleButton
            type="radio"
            size={size}
            key={value}
            id={`toggle-${value}-${idPrefix}`}
            value={value}
            variant={active ? 'secondary' : 'outline-secondary'}
            className={combinedClassName}
            disabled={disabled}
            onClick={onClick}
          >
            <div className="d-flex gap-1 align-items-center justify-content-center h-100">
              {iconName && <i className={iconName} />}
              <span>{label}</span>
            </div>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ToggleGroupButton;
